import { classNames } from "@/react/helpers/twMergeWithCN";

import type { ActiveItem } from "./CommunityMenu/SpaceGroupList/types";
import { SpaceView } from "./CommunityMenu/SpaceList/SpaceView";
import { SpaceGroupDragOverlay } from "./SpaceGroupDragOverlay";

interface SpaceListDragOverlayProps {
  activeItem: ActiveItem;
}

export function SpaceListDragOverlay({
  activeItem,
}: SpaceListDragOverlayProps) {
  const { type, item } = activeItem;
  const className =
    "scale-[1.02] transition-transform duration-75 ease-in opacity-100 pointer-events-none cursor-grab";
  if (type === "spaceGroup") {
    return <SpaceGroupDragOverlay spaceGroup={item} className={className} />;
  }
  if (type === "space") {
    return (
      <SpaceView
        space={item}
        className={classNames(
          className,
          "rounded-lg bg-c-sidebar-hover shadow-lg",
        )}
        isDragOverlay
      />
    );
  }
  return null;
}
